import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import { HeaderGridRow, GridItem } from "../../DisputeList.styled";

const Header = (props) => {
  const { t, page } = props;

  return (
    <HeaderGridRow
      column={
        page === "main"
          ? "10% 10% 10% 15% 10% 24% 8% 13%"
          : "10% 10% 17% 12% 28% 10% 13%"
      }
      marginBottom="0px"
      gridGap="0rem"
      marginTop="0px"
    >
      <GridItem
        padding="8px"
        fontWeight="700"
        radius="5px 0px 0px 0px"
        borderRight="1px solid #fff"
      >
        {t("DISPUTES_DATE")}
      </GridItem>
      {page === "main" && (
        <GridItem
          padding="8px"
          fontWeight="700"
          textAlign="left"
          borderRight="1px solid #fff"
        >
          {t("DISPUTES_SITE")}
        </GridItem>
      )}
      <GridItem padding="8px" fontWeight="700" borderRight="1px solid #fff">
        {t("DISPUTES_RESPONSIBILITY")}
      </GridItem>
      <GridItem
        padding="8px"
        fontWeight="700"
        textAlign="left"
        borderRight="1px solid #fff"
      >
        {t("DISPUTES_RESPONSIBLE")}
      </GridItem>
      <GridItem
        padding="8px"
        fontWeight="700"
        textAlign="left"
        borderRight="1px solid #fff"
      >
        {t("DISPUTES_FEE")}
      </GridItem>
      <GridItem
        padding="8px"
        fontWeight="700"
        textAlign="left"
        borderRight="1px solid #fff"
      >
        {t("DISPUTES_DETAILS")}
      </GridItem>
      <GridItem padding="8px" fontWeight="700" borderRight="1px solid #fff">
        {t("DISPUTES_REPORTER")}
      </GridItem>
      <GridItem padding="8px" fontWeight="700" radius="0px 5px 0px 0px">
        {t("DISPUTES_ACTIONS")}
      </GridItem>
    </HeaderGridRow>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

Header.defaultProps = {
  page: "main",
};

export default withTranslation()(Header);
